var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "1c_data" }, [
    _vm.data.length == 0
      ? _c("div", { staticClass: "panel-tag" }, [
          _vm._v(
            "\n\t\tУвага! Дана ЗД не перебуває в оренді підприємств ГК ІМК. Її придбання потребує отримання відмови від переважного права на придбання від поточного орендаря ЗД, а також передбачає подальші орендні взаємовідносини покупця із поточним орендарем ЗД – сторонньою компанією, яка не входить до складу ГК ІМК!\n\t"
          ),
        ])
      : _c(
          "div",
          { staticClass: "panel-body" },
          [
            _vm.has_empty_daz
              ? _c("div", { staticClass: "panel-tag" }, [
                  _vm._v(
                    "\n\t\t\tУвага! Дана ЗД не перебуває в оренді підприємств ГК ІМК. Її придбання потребує отримання відмови від переважного права на придбання від поточного орендаря ЗД, а також передбачає подальші орендні взаємовідносини покупця із поточним орендарем ЗД – сторонньою компанією, яка не входить до складу ГК ІМК!\n\t\t"
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { staticClass: "left_pais", attrs: { sm: "4" } },
                  _vm._l(this.data, function (pai, idx) {
                    return _c(
                      "div",
                      { staticClass: "bg-light rounded-top mb-2" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "accordion accordion-hover accordion-clean",
                            attrs: { id: "js_list_accordion" },
                          },
                          [
                            _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-header border" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "card-title",
                                    class: {
                                      collapsed: !pai.is_active,
                                      "is_real_active border border-danger":
                                        _vm.check_is_current(pai),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setActivePai(idx)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fal fa-globe-americas width-2 fs-xl",
                                    }),
                                    _vm._v(
                                      "\n\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.getOwner1c(pai)) +
                                        "\n\n\t\t\t\t\t\t\t\t\t"
                                    ),
                                    _c("div", { staticClass: "ml-2" }, [
                                      _c("small", [
                                        _vm._v(_vm._s(pai.params.kadastr)),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("b-col", { staticClass: "right_pais", attrs: { sm: "8" } }, [
                  _c("div", { staticClass: "1c_fields" }, [
                    _vm.pai_1c_active != null
                      ? _c(
                          "div",
                          { staticClass: "descriptions border p-3" },
                          _vm._l(_vm.pai_fields_active, function (info) {
                            return _vm.can_show_1c_field(info)
                              ? _c("div", { staticClass: "blck" }, [
                                  _c("b", [_vm._v(_vm._s(info.field_name))]),
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t= " +
                                      _vm._s(info.field_val) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ])
                              : _vm._e()
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }